import React, { useState } from "react";
import classnames from "classnames";
import Modal from "../../../ui/Modal/Modal";
import Button from "../../../ui/Button/Button";
import ButtonGroup from "../../../ui/ButtonGroup/ButtonGroup";
import Select from "../../../ui/Select/Select";
import InputField from "../../../ui/InputField/InputField";
import CpcInputField from "../../../ui/InputField/CpcInputField";
import FormMessage from "../../../ui/FormMessage/FormMessage";
import Loader from "../../../ui/Loader/Loader";
import CampaignSelect from "../../../components/CampaignsSelect";

import { teaserStatusOptions } from "../../../constants";

import "./MassCopy.scss";
import useGlobals from "../../../hooks/useGlobals";

const actionCopy = "copy";
const actionUpdate = "update";

const MassCopy = ({
  onCancel,
  onConfirm,
  loading,
  confirmLoading,
  categories,
  count,
  errors
}) => {
  const isLoading = loading || confirmLoading;
  const [data, setData] = useState({});
  const globals = useGlobals();

  const mpaaRatingOptions =
    globals?.mpaa_rating?.map(rating => {
      return {
        label: rating.name,
        value: rating.id
      };
    }) ?? [];

  const handleMpaaRatingChange = ({ value: mpaa_rating }) => {
    setData(prevState => ({
      ...prevState,
      mpaa_rating
    }));
  };

  const handleCampaignSelect = item => {
    setData({ ...data, campaign: item.value });
  };

  const handleCategorySelect = item => {
    setData({ ...data, category: item.value });
  };

  const handleStatusSelect = item => {
    setData({ ...data, status: item.value });
  };

  const handleInputChange = e => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleActionSelect = action => {
    setData({ ...data, action });
  };

  const handleConfirm = () => {
    onConfirm(data, {});
  };

  const handleConfirmContinue = () => {
    onConfirm(data, { continue: true });
  };

  const formInvalid = () => {
    if (!data.action) {
      return true;
    }

    if (data.action == actionCopy && !data.campaign) {
      return true;
    }

    const { action, ...others } = data;

    const values = Object.values(others);
    if (values.length == 0) {
      return true;
    }

    window.data = values;
    return values.filter(val => !!val).length == 0;
  };

  return (
    <Modal className="mass-copy-modal" onClose={onCancel}>
      <div className="modal__header">
        <div className="modal__title">Групповые изменения: {count} анонсов</div>
        <div className="modal__controls">
          <Button onClick={onCancel} color="gray">
            Отменить
          </Button>
          <Button
            onClick={handleConfirm}
            color="blue"
            disabled={isLoading || formInvalid()}
          >
            Применить
          </Button>
          <Button
            onClick={handleConfirmContinue}
            color="blue"
            disabled={isLoading || formInvalid()}
          >
            Применить и подолжить
          </Button>
        </div>
      </div>

      <div className="modal__body">
        {confirmLoading && <Loader />}

        <div
          className={classnames("mass-copy-modal__fields", {
            "mass-copy-modal__fields-hidden": confirmLoading
          })}
        >
          <div className="mass-copy-modal__action-title">Что сделать:</div>

          <ButtonGroup
            items={[
              { title: "Копировать", code: actionCopy },
              { title: "Изменить", code: actionUpdate }
            ]}
            selected={data.action}
            onClick={handleActionSelect}
          />

          <div className="mass-copy-modal__selects">
            <CampaignSelect
              placeholder="Копировать в кампанию"
              className="campaign"
              label="Копировать в кампанию:"
              value={data.campaign}
              onSelect={handleCampaignSelect}
            />
            <Select
              placeholder="Выбор категории"
              className="category"
              label="Изменить категорию:"
              options={categories}
              value={data.category}
              onSelect={handleCategorySelect}
            />
            <Select
              placeholder="Изменить статус"
              className="status"
              label="Изменить статус:"
              options={teaserStatusOptions}
              onSelect={handleStatusSelect}
            />
            <CpcInputField
              label="Изменить CPC"
              placeholder="Ввести CPC"
              onChange={handleInputChange}
              value={data.cpc}
              name="cpc"
              error={errors.cpc && errors.cpc.length != 0}
            />
          </div>

          <FormMessage messages={errors.cpc} color="error" />

          <div className="mass-copy-modal__replace">
            <InputField
              label="Заменить в ссылках часть URL'а:"
              placeholder="Например, source=3"
              errors={errors.url_old}
              name="url_old"
              value={data.url_old}
              onChange={handleInputChange}
            />
            <InputField
              label="На следующий элемент:"
              placeholder="Например, source=4"
              name="url_new"
              errors={errors.url_new}
              value={data.url_new}
              onChange={handleInputChange}
            />
            <div
              style={{
                marginTop: 18
              }}
            >
              <Select
                value={data.mpaa_rating}
                options={mpaaRatingOptions}
                placeholder={"Выбор рейтинга MPA"}
                label={"Рейтинг MPA"}
                onSelect={handleMpaaRatingChange}
              />
            </div>
            <InputField
              label="Дисклеймер:"
              placeholder="Введите дисклеймер"
              name="disclaimer"
              errors={errors.disclaimer}
              value={data.disclaimer}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

MassCopy.defaultProps = {
  errors: {}
};

export default MassCopy;
